import {Component, EventEmitter, Input, OnInit, Output, ViewChild, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';

@Component({
    selector: 'app-confirm-popup',
    templateUrl: './confirm-popup.component.html',
    styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmPopupComponent implements OnInit {

    @Input() message: string;

    @Output() action: EventEmitter<boolean>;

    @ViewChild('confirmPopupTemplate') confirmPopupTemplateRef: TemplateRef<any>;

    modalRef: BsModalRef;

    constructor(private modalService: BsModalService) {
        this.action = new EventEmitter();
    }

    ngOnInit() {
    }

    show() {
        this.modalRef = this.modalService.show(this.confirmPopupTemplateRef, {class: 'modal-sm'});
    }

    hide() {
        this.modalRef.hide();
    }

    yes() {
        this.action.emit(true);
        this.hide();
    }

    no() {
        this.action.emit(false);
        this.hide();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/confirm-popup/confirm-popup.component.ts